import React from "react"
import { Box, Button, Typography, makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	divider: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(2),
	},
	flex: {
		display: "flex",
		justifyContent: "end",
	},
	btnReload: {
		textTransform: "initial",
		backgroundColor: theme.palette.secondary.dark,
		color: theme.palette.common.white,
		fontWeight: "initial",
	},
}))

const FileDeleteModal = ({ navigate, content, btnText }) => {
	const classes = useStyles()

	return (
		<Box>
			<Typography variant="body2">{content}</Typography>
			<hr className={classes.divider} />
			<Box className={classes.flex}>
				<Button variant="contained" color="secondary" className={classes.btnReload} onClick={navigate}>
					{btnText}
				</Button>
			</Box>
		</Box>
	)
}

export default FileDeleteModal
